import React from "react";
import { Box, BoxProps } from "@chakra-ui/react";

export const InfoIcon: React.FC<BoxProps> = (props) => (
  <Box as="span" display="inline-block" {...props}>
    <svg
      width="15"
      height="15"
      viewBox="0 0 15 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.39339 5.33322C5.55013 4.88767 5.85949 4.51196 6.26669 4.27265C6.6739 4.03333 7.15266 3.94585 7.61818 4.0257C8.0837 4.10555 8.50594 4.34757 8.81011 4.70891C9.11428 5.07025 9.28076 5.52757 9.28006 5.99989C9.28006 7.33322 7.28006 7.99989 7.28006 7.99989M7.33341 10.6665H7.34008M14.0001 7.33317C14.0001 11.0151 11.0153 13.9998 7.33341 13.9998C3.65152 13.9998 0.666748 11.0151 0.666748 7.33317C0.666748 3.65127 3.65152 0.666504 7.33341 0.666504C11.0153 0.666504 14.0001 3.65127 14.0001 7.33317Z"
        stroke="#595959"
        strokeWidth={1.33333}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  </Box>
);
